'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinnerContainer = exports.SuffixContainer = exports.PrefixContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: ', ';\n  left: 12px;\n'], ['\n  position: absolute;\n  top: ', ';\n  left: 12px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  position: absolute;\n  top: ', ';\n  right: 12px;\n'], ['\n  position: absolute;\n  top: ', ';\n  right: 12px;\n']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['\n  top: ', ';\n  cursor: not-allowed;\n'], ['\n  top: ', ';\n  cursor: not-allowed;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactMaskedinput = require('react-maskedinput');

var _reactMaskedinput2 = _interopRequireDefault(_reactMaskedinput);

var _spinner = require('@hixme-ui/spinner');

var _spinner2 = _interopRequireDefault(_spinner);

var _icon = require('@hixme-ui/icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

var _InputBase = require('./InputBase');

var _InputBase2 = _interopRequireDefault(_InputBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrefixContainer = exports.PrefixContainer = _styledComponents2.default.span(_templateObject, function (_ref) {
  var mini = _ref.mini;
  return mini ? '5px' : '9px';
});

var SuffixContainer = exports.SuffixContainer = _styledComponents2.default.span(_templateObject2, function (_ref2) {
  var mini = _ref2.mini;
  return mini ? '5px' : '9px';
});

var SpinnerContainer = exports.SpinnerContainer = SuffixContainer.extend(_templateObject3, function (_ref3) {
  var mini = _ref3.mini;
  return mini ? '5px' : '12px';
});

// Remove all styled specific props as to not
// pass them onto the Masked component.
// This is to prevent React errors in the console
var Masked = _InputBase2.default.withComponent(function (_ref4) {
  var date = _ref4.date,
      error = _ref4.error,
      large = _ref4.large,
      mini = _ref4.mini,
      phone = _ref4.phone,
      search = _ref4.search,
      ssn = _ref4.ssn,
      props = (0, _objectWithoutProperties3.default)(_ref4, ['date', 'error', 'large', 'mini', 'phone', 'search', 'ssn']);
  return _react2.default.createElement(_reactMaskedinput2.default, props);
});

var InputTextarea = _InputBase2.default.withComponent('textarea');

var Input = function Input(_ref5) {
  var currency = _ref5.currency,
      date = _ref5.date,
      loading = _ref5.loading,
      mask = _ref5.mask,
      percentage = _ref5.percentage,
      phone = _ref5.phone,
      ssn = _ref5.ssn,
      submitting = _ref5.submitting,
      textarea = _ref5.textarea,
      props = (0, _objectWithoutProperties3.default)(_ref5, ['currency', 'date', 'loading', 'mask', 'percentage', 'phone', 'ssn', 'submitting', 'textarea']);

  if (currency) {
    var mini = props.mini;

    return _react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      _react2.default.createElement(_InputBase2.default, (0, _extends3.default)({ currency: true }, props)),
      _react2.default.createElement(
        PrefixContainer,
        props,
        _react2.default.createElement(
          _text2.default,
          { light: true, large: !mini },
          '$'
        )
      )
    );
  }

  if (percentage) {
    var _mini = props.mini;

    return _react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      _react2.default.createElement(_InputBase2.default, props),
      _react2.default.createElement(
        SuffixContainer,
        props,
        _react2.default.createElement(
          _text2.default,
          { light: true, large: !_mini },
          '%'
        )
      )
    );
  }

  if (phone || ssn || date || mask) {
    var masked = mask || '';
    if (phone) masked = '(111) 111 - 1111';
    if (ssn) masked = '111 - 11 - 1111';
    if (date) masked = '11/11/1111';
    return _react2.default.createElement(Masked, (0, _extends3.default)({ mask: masked }, props));
  }

  if (textarea) {
    return _react2.default.createElement(InputTextarea, props);
  }

  if (submitting || loading) {
    var _mini2 = props.mini;

    return _react2.default.createElement(
      'div',
      { style: { position: 'relative' } },
      _react2.default.createElement(_InputBase2.default, (0, _extends3.default)({ disabled: true }, props)),
      _react2.default.createElement(
        SpinnerContainer,
        { mini: _mini2 },
        _react2.default.createElement(
          _spinner2.default,
          { animate: true, duration: '2s' },
          _react2.default.createElement(_icon2.default, { cog: true, lighter: true, size: 1.2 })
        )
      )
    );
  }

  return _react2.default.createElement(_InputBase2.default, props);
};

Input.displayName = 'hui:Input';
Input.huiName = 'Input';

Input.propTypes = {
  currency: _propTypes2.default.bool,
  date: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  mask: _propTypes2.default.string,
  percentage: _propTypes2.default.bool,
  phone: _propTypes2.default.bool,
  ssn: _propTypes2.default.bool,
  submitting: _propTypes2.default.bool,
  textarea: _propTypes2.default.bool,
  mini: _propTypes2.default.bool
};

Input.defaultProps = {
  currency: false,
  date: false,
  loading: false,
  mask: null,
  percentage: false,
  phone: false,
  ssn: false,
  submitting: false,
  textarea: false,
  mini: false
};

exports.default = Input;
//# sourceMappingURL=Input.js.map


//////////////////
// WEBPACK FOOTER
// ../input/lib/Input.js
// module id = 701
// module chunks = 0